import React from 'react';
import PageTopButton from '@components/common/pageTopButton';
import JobPostModalWrap from '@components/common/jobPostModal/JobPostModalWrap';
import JobPostList from '@components/acca/test/jobPostList';
import Introduce from '@components/acca/test/introduce';
import ServiceList from '@components/acca/test/serviceList';
import AccaTestList from '@components/acca/test/accaTestList';
import PositionList from '@components/acca/test/positionList';
import AccaAtoZList from '@components/acca/test/accaAtoZList';
import AccaReviewList from '@components/acca/test/accaReviewList';
import { useAccCenterApplyCount } from '@repository/acc';
import classnames from 'classnames/bind';
import styles from './accaGate.module.scss';
import CounterAnimation from '@components/acca/test/counterAnimation';
const cx = classnames.bind(styles);

const AccaGate = () => {
  const { data } = useAccCenterApplyCount();

  return (
    <>
      <JobPostModalWrap>
        <div className={cx('accaGateArea')}>
          <div className={cx('section', 'section1')}>
            <div className={cx('sectionInner')}>
              <div className={cx('noticeArea')}>
                {/* 응시자수 영역 */}
                <div className={cx('count')}>
                  현재 누적 응시자 수 :
                  <em className={cx('em')}>
                    {' '}
                    <CounterAnimation targetValue={data?.total} />
                  </em>
                </div>
                <div className={cx('title')}>역량검사 한 번으로, 취업 준비 끝!</div>
              </div>

              {/* 역량 유형 & 역검센터 서비스 영역 */}
              <div className={cx('serviceArea')}>
                {/* 역검 소개 영역 */}
                <Introduce />

                {/* 응시, 결과표 영역 */}
                <ServiceList />
              </div>
            </div>
          </div>

          {/* 최근 응시내역 영역 */}
          <AccaTestList />

          {/* 역검 결과 맞춤형 포지션 추천 영역 */}
          <PositionList />

          {/* 역검 활용 공고 */}
          <JobPostList />

          <div className={cx('section')}>
            <div className={cx('sectionInner')}>
              {/* 역검 A to Z 영역 */}
              <AccaAtoZList />

              {/* 역검 합격 후기 영역 */}
              <AccaReviewList />
            </div>
          </div>

          {/* 페이지 Top 버튼 영역 */}
          <PageTopButton />
        </div>
      </JobPostModalWrap>
    </>
  );
};

export default AccaGate;
